const DEFAULT_CONFIG = {
    host: '',
};

export default DEFAULT_CONFIG;
